import React from "react";
import VerticalCard from "./VerticalCard";

function SysGuardCardOverview() {
  return <VerticalCard />;
}

export default SysGuardCardOverview;
